import { Component, Inject, InjectionToken, Input, OnInit, Optional } from '@angular/core';
import { environment } from 'environments/environment';

export const APP_VERSION = new InjectionToken<string>('APP_VERSION');

@Component({
    selector: 'iapply-version',
    templateUrl: './iapply-version.component.html',
    styleUrls: ['./iapply-version.component.scss'],
    imports: []
})
export class iApplyVersionComponent implements OnInit
{
    // TODO: Get all inputs form the configuration service.
    @Input() title: string = environment.productTitle || 'iApply-NEXT';
    @Input() showCopyright: boolean = true;

    currentYear: number;
    appVersion: string = 'unknown';

    constructor(
        @Optional() @Inject(APP_VERSION) version?: string
    )
    {
        this.appVersion = version ?? '';
    }

    ngOnInit(): void
    {
        this.currentYear = new Date().getFullYear();
    }
}
